/** @format */

import type { ImportJobStatus } from "@question-bank/shared";
import { importJobStatusLabels } from "../utils/importJobs";

/** Same pairs as the question status badges: pale ground, dark text, so the label stays readable. */
const STATUS_BADGE_CLASSES: Record<ImportJobStatus, string> = {
	pending: "bg-amber-100 text-amber-800",
	running: "bg-blue-100 text-blue-800",
	complete: "bg-green-100 text-green-800",
	failed: "bg-red-100 text-red-800",
	cancelled: "bg-slate-100 text-slate-700",
	rolling_back: "bg-violet-100 text-violet-800",
	rolled_back: "bg-slate-100 text-slate-800",
};

/** Coloured status used on the import history list and the import job screen. */
export const ImportStatusBadge = ({ status, failedReason }: { status: ImportJobStatus; failedReason?: string }) => {
	const label = importJobStatusLabels[status];
	// The history table scrolls, so a floating tip is clipped. The native tooltip is not.
	const reason = status === "failed" ? `Reason: ${failedReason ?? "Unknown failure"}` : undefined;
	return (
		<span
			className={`inline-flex rounded-full px-2 py-0.5 text-xs font-semibold ${STATUS_BADGE_CLASSES[status]}`}
			title={reason}
			aria-label={reason ? `${label}. ${reason}` : undefined}
		>
			{label}
		</span>
	);
};
